<template>
    <div class="input-field">
        <i v-if="icon" class="input-field__icon" :class="icon" @click="$emit('icon-clicked')" />
        <label class="input-field__label" :class="{ 'input-field__label--show': isInput }">{{ label }}</label>
        <input @keyup.enter="$emit('enter')" class="input-field__input" type="text" :class="{
            'input-field__input--padding-top': isInput,
        }" v-model="inputText" :placeholder="placeholder" />
        <div class="input-field__matches" v-if="inputText.length">
            <template v-if="matchValues.length">
                <!-- Show 5 elements. -->
                <div v-for="item in matchValues.slice(0, 5)" class="input-field__matches-item" :key="item.id"
                    @click="$emit('select-player', item), (inputText = '')" :class="{
                        disabled: !item.isLocatedInTrackZone,
                    }">
                    {{ item.firstname }} {{ item.lastname }}
                    <div>{{ item.playerNumber }} - {{ classifications[item.classification].namePl }}</div>
                </div>
            </template>
            <template v-else>
                <div class="input-field__matches-item">
                    <b>Brak wyników wyszukiwania.</b>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
export default {
    data() {
        return {
            inputText: '',
            matchValues: null,
        }
    },
    props: {
        values: {
            type: Array,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        hint: {
            type: String,
            default: '',
        },
        icon: {
            type: String,
            default: null,
        },
    },
    computed: {
        ...mapGetters(['classifications']),
        isInput() {
            return Boolean(this.hint || this.inputText)
        },
        placeholder() {
            return this.hint ? this.hint : this.label
        },
    },
    methods: {
        playerNumber(value) {
            return Number(value.playerNumber)
        },
        firstname(value) {
            return String(value.firstname).toLowerCase()
        },
        lastname(value) {
            return String(value.lastname).toLowerCase()
        },
    },
    watch: {
        inputText(text) {
            this.matchValues = _.filter(this.values, (value) => {
                return (
                    this.playerNumber(value) ==
                    text.toLowerCase().trim() ||
                    this.firstname(value).substr(0, text.trim().length) ==
                    text.toLowerCase().trim() ||
                    this.firstname(value).normalize("NFD").replace(/\u0142/g, "l").replace(/[\u0300-\u036f]/g, "").substr(0, text.trim().length) ==
                    text.toLowerCase().trim() ||
                    this.lastname(value).substr(0, text.trim().length) ==
                    text.toLowerCase().trim() ||
                    this.lastname(value).normalize("NFD").replace(/\u0142/g, "l").replace(/[\u0300-\u036f]/g, "").substr(0, text.trim().length) ==
                    text.toLowerCase().trim() ||
                    (this.firstname(value) + ' ' + this.lastname(value)).substr(
                        0,
                        text.trim().length
                    ) == text.toLowerCase().trim()
                )
            })
        },
    },
}
</script>

<style lang="scss" scoped>
.disabled {
    opacity: 0.7;
}

.input-field {
    position: relative;
    height: 40px;
    min-height: 40px;
    border-radius: 4px;
    box-shadow: 0 8px 12px 0 rgba(0, 0, 0, 0.1), 0 0 2px 0 rgba(55, 71, 79, 0.2);
    background-color: $white;
    display: flex;
    box-sizing: border-box;
    padding: 0;
    outline: none;

    // Icon.
    &__icon {
        width: 32px;
        height: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 18px;
        cursor: pointer;
        padding-left: 12px;
        margin: auto 0;
        color: $charcoal-grey;
    }

    // input
    &__input {
        border: none;
        position: relative;
        background: transparent;
        width: 100%;
        padding-left: 10px;
        padding-right: 10px;
        transition: padding 0.3s;
        overflow: hidden;

        &--padding-top {
            padding-top: 15px;
        }

        &::placeholder {
            color: $greyish-brown;
            opacity: 1;
        }
    }

    &__matches {
        position: absolute;
        top: 40px;
        height: 100%;
        left: 0;
        right: 0;
        background-color: $white;
        display: flex;
        flex-direction: column;
        height: auto;
        z-index: 9999;
        box-shadow: 0 8px 12px 0 rgba(0, 0, 0, 0.1),
            0 0 2px 0 rgba(55, 71, 79, 0.2);
        border-radius: 4px;
        overflow: hidden;

        &-item {
            padding: 10px 16px;
            border-bottom: 1px solid $pale-grey;
            line-height: 1.43;
            cursor: pointer;

            &:hover:not(.disabled) {
                background-color: $light-grey;
            }
        }
    }

    // Label.
    &__label {
        position: absolute;
        opacity: 0;
        top: 2px;
        left: 38px;
        font-size: 12px;
        color: $charcoal-grey;
        transition: all 0.3s;

        &--show {
            opacity: 1;
        }
    }
}
</style>
